export default "__VITE_ASSET__BowY1IXA__"